import { useQuery } from '@tanstack/react-query'
import type { AdminGetLiquidityAccountsParams } from '../api'
import { adminGetLiquidityAccountsOptions } from './admin-liquidity.options'

export const useAdminGetLiquidityAccounts = (
  params: AdminGetLiquidityAccountsParams,
) => {
  return useQuery(adminGetLiquidityAccountsOptions(params))
}
